// src/firebase/auth.observer.js
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase.config";

/**
 * Listen for authentication state changes.
 * @param {function} callback - Receives the user object or null.
 * @returns {function} Unsubscribe function.
 */
export const observeAuthState = (callback) => {
    return onAuthStateChanged(auth, callback);
};

